import React from 'react';
import { NavLink } from 'react-router-dom';

// Route backing the "Orders View" dashboard tab (the rentals gantt overview).
// Exported so the sidenav default-path resolver can point non-At-A-Glance
// users here without duplicating the literal.
export const ORDERS_VIEW_PATH = '/dashboard/orders-overview';

// Shared "Orders View" tab rendered across every dashboard sub-nav (Schedule,
// At-A-Glance, To-Do's, Payments) between At-A-Glance and To-Do's. Kept as a
// single component so the label + path stay in sync everywhere, mirroring the
// AtAGlanceLink / NotificationsTab pattern. Unlike At-A-Glance it has no role
// gate — it's available to anyone who can reach the dashboard.
const OrdersViewLink = () => (
  <NavLink to={ORDERS_VIEW_PATH} activeClassName='selected'>
    Orders View
  </NavLink>
);

export default OrdersViewLink;
